import { render, staticRenderFns } from "./template-email-svg.vue?vue&type=template&id=c4c3395a"
import script from "./template-email-svg.vue?vue&type=script&lang=js"
export * from "./template-email-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports